module.exports = __webpack_public_path__ + "img/time-icon.5057ce3c.svg";